import { Component, Inject, Input, input } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogActions } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-add-product-dialog',
  standalone: true,
  templateUrl: './add-product-dialog.component.html',
  styleUrls: ['./add-product-dialog.component.scss'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSlideToggleModule,
    MatButtonModule,
    MatIconModule,
    MatDialogActions
  ],
})

export class AddProductDialogComponent {
  productForm: FormGroup;
  isEditMode: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<AddProductDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) {
    this.productForm = this.fb.group({
      name: [data?.productData?.name || '', Validators.required],
      description: [data?.productData?.description || ''],
      price: [data?.productData?.price || '', Validators.required],
      is_on_sale: [data?.productData?.is_on_sale || false],
      sale_price: [data?.productData?.sale_price || ''],
    });

    this.isEditMode = data?.isEditMode || false;
  }


  onSubmit(): void {
    if (this.productForm.invalid) {
      return;
    }

    const newProduct = this.productForm.value;

    this.dialogRef.close(newProduct);
  }


  onCancel(): void {
    this.dialogRef.close();
  }

} 